<template>
	<div class="left_small_tbl">
		<h4 class="inner_h5">
			User Defined Group List
			<span class="int_type2 mgl_15">
				<input type="text" v-model="searchName" class="int_type" v-on:keyup.enter="selectList" autocomplete="off" />
			</span>
			<span>
				<a href="javascript:void(0);" class="gray_bt" @click="selectList()">Search</a>
			</span>
			<span>
				<a href="javascript:void(0);" class="gray_bt" @click="add()" style="float:right;">Add</a>
			</span>
		</h4>
		<div class="fixed-table-container">
			<div class="table-wrapper">
				<table id="item_list" class="list_tbl tbl_pointer">
					<colgroup>
						<col style="width: 5%" />
						<col />
						<col style="width: 12%" />
						<col style="width: 18%" />
						<col style="width: 18%" />
					</colgroup>
					<thead>
						<tr>
							<th class="al_center">
								<div class="th-text">No</div>
							</th>
							<th class="al_center">
								<div class="th-text">Group Name</div>
							</th>
							<th class="al_center">
								<div class="th-text">Order No</div>
							</th>
							<th class="al_center">
								<div class="th-text">Delete</div>
							</th>
							<th class="al_center">
								<div class="th-text">Rename</div>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(group, index) of list" v-bind:key="index" :class="ud_no === group.udNo ? 'on td' : ''">
							<td @click="clickGroup(group.udNo)">{{ index + 1 }}</td>
							<td @click="clickGroup(group.udNo)">{{ group.name }}</td>
							<td @click="clickGroup(group.udNo)">{{ group.orderNo }}</td>
							<td class="al_center"><a href="javascript:void(0)" class="gray_bt" @click="deleteCheck(group.udNo)">Delete</a></td>
							<td class="al_center"><a href="javascript:void(0)" class="gray_bt" @click="updateUserDefinedGroup(group.udNo)">Rename</a></td>
						</tr>
					</tbody>
				</table>
				<div style="text-align:right;padding-top:5px;padding-right:10px;">Total Count : {{ list.length | commaSeparated }}</div>
				<div class="view_bottom_bt"></div>
				<user-defined-group-pop ref="modal" @change="changeGroupList" />
			</div>
		</div>
	</div>
</template>

<script>
import UserDefinedGroupPop from '@/views/item/UserDefinedGroup/UserDefinedGroupPop';
import { apiDeleteUserDefinedGroup, apiSelectUserDefinedGroups } from '@/api/item/userDefined';
import { objectToUrlParam } from '@/api/util';

export default {
	name: 'UserDefinedGroupList',
	data: function() {
		return {
			list: [],
			ud_no: 0,
			searchName: '',
		};
	},
	methods: {
		clickGroup(udNo) {
			this.ud_no = udNo;
			this.$emit('click', this.ud_no);
		},
		add() {
			this.$refs.modal.openModal();
		},
		async changeGroupList(udNo) {
			await this.selectList();
			this.clickGroup(udNo);
		},
		selectList() {
			const param = objectToUrlParam({ name: this.searchName });
			const vm = this;
			apiSelectUserDefinedGroups(param).then(function(value) {
				vm.list = value.data;
			});
		},
		async deleteCheck(ud_no) {
			const vm = this;
			await this.$alertify.confirm('Do you want to delete it?', async () => vm.deleteUserDefinedGroup(ud_no));
		},
		async deleteUserDefinedGroup(ud_no) {
			await apiDeleteUserDefinedGroup(ud_no);
			await this.selectList();
			this.$toast.success('Deleted');
		},
		async updateUserDefinedGroup(ud_no) {
			this.$nextTick(() => {
				this.$refs.modal.selectUserDefinedGroup(ud_no);
				this.$refs.modal.openModal();
			});
		},
	},
	components: {
		UserDefinedGroupPop,
	},
	mounted() {
		this.selectList();
	},
};
</script>

<style scoped></style>
